import * as React from 'react';

import BoxAi from './BoxAi';

export const boxAi = () => <BoxAi />;

export default {
    title: 'Icon/Line/BoxAi',
    component: BoxAi,
    parameters: {
        notes: "`import BoxAi from 'box-ui-elements/es/icon/line/BoxAi';`",
    },
};
